export enum StatementType {
    byTransaction = 'OLD',
    byRefund = 'NEW'
}

export default [
    StatementType.byTransaction,
    StatementType.byRefund
]